"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodsTable = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
function MethodsTable(attrs) {
    var data = attrs.data, api = attrs.api;
    var methods = data.docs.typescript[api].methods;
    return (0, mithril_1.default)(_1.Table, [
        (0, mithril_1.default)('tr', [
            (0, mithril_1.default)('th[style=min-width:220px]', 'Name'),
            (0, mithril_1.default)('th', 'Type'),
            (0, mithril_1.default)('th', 'Description')
        ]),
        methods.map(renderRow)
    ]);
}
exports.MethodsTable = MethodsTable;
function renderRow(method) {
    var signature = method.signatures[0];
    return (0, mithril_1.default)('tr', [
        (0, mithril_1.default)('td', (0, mithril_1.default)('code', method.name)),
        (0, mithril_1.default)('td', signature.type),
        (0, mithril_1.default)('td', mithril_1.default.trust(signature.documentation.contentsRaw))
    ]);
}
